import { sleep } from './Sleep';

export const smoothLoading = () => sleep(1000);